// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"d4086642","278":"a328e94e","480":"3ff0c19e","787":"097d8410","790":"21ac0383","809":"54788e4b","881":"45edaff3"}[chunkId] + ".chunk.js";
};